import { render } from "./ChooseSlogan.vue?vue&type=template&id=1604b818&scoped=true&ts=true"
import script from "./ChooseSlogan.vue?vue&type=script&lang=ts"
export * from "./ChooseSlogan.vue?vue&type=script&lang=ts"

import "./ChooseSlogan.vue?vue&type=style&index=0&id=1604b818&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1604b818"]])

export default __exports__